import type { IAppSettings } from '../types';

const getAppSettings = async (): Promise<IAppSettings> => {
  return fetch('/app.settings.json').then((response) => response.json());
};

export const appSettings = await getAppSettings();
